import { FunctionComponent } from 'react'

import { Button, Modal, Text, VStack } from 'native-base'

export type OpportunityDeletionSuccessModalProps = {
  isOpen: boolean
  onClose(): void
}

export const OpportunityDeletionSuccessModal: FunctionComponent<
  OpportunityDeletionSuccessModalProps
> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <Modal.Content maxW="656px" borderRadius="32px" px={8} py={10} alignItems="center">
        <Modal.Body p={0} alignItems="center">
          <VStack space={4} alignItems="center">
            <Text
              fontSize="22px"
              fontWeight={700}
              lineHeight="28px"
              color="gray.700"
              textAlign="center">
              Solicitação enviada com sucesso
            </Text>
            <Text fontSize="16px" lineHeight="24px" color="gray.500" textAlign="center">
              Sua solicitação de exclusão da oportunidade foi enviada para análise. Você será
              notificado sobre o andamento em até 72 horas úteis. Agradecemos a sua colaboração.
            </Text>
          </VStack>
        </Modal.Body>

        <Modal.Footer
          px={0}
          mt={8}
          width="100%"
          borderWidth={0}
          borderColor="transparent"
          justifyContent="center">
          <Button flex={1} colorScheme="gray" onPress={onClose} maxWidth={450}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
